import { BaseClient } from '../client';

/**
 * POST /api/Usuarios/EsqueceuSenha?email=
 * O parâmetro é tipo simples no minimal API e é lido da query string.
 * A rota responde 200 com uma string em todos os casos.
 */
export const postEsqueceuSenha = async (email: string): Promise<string> => {
	const response = await BaseClient.post<string>('/Usuarios/EsqueceuSenha', null, {
		params: { email: email.trim() },
	});

	return typeof response.data === 'string' ? response.data : String(response.data ?? '');
};
